//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('poFinishPoFinishComps', {
//        templateUrl: 'views/components/views/poFinishPoFinishComps/poFinishPoFinishComps.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'stockSearchService', function ($stateParams, stateService, stockSearchService) {

//            // #region VARIABLES & DEFINITIONS
            
//            const vm = this;
//            let p2PoFinishKeyno = $stateParams.p2_pofinish_keyno;
            
//            vm.model = {
//                bgComponentSelection: {
//                    selected: 'MINE',
//                    buttons: [
//                        { id: 'MINE', label: 'pofinishcomps_mine', color: 'primary', onClick: () => vm.model.bgComponentSelection.selected = 'MINE' },
//                        { id: 'ALL', label: 'pofinishcomps_all', color: 'primary', onClick: () => vm.model.bgComponentSelection.selected = 'ALL' }
//                    ]
//                },
//                itemsListComponents: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE CALL
            
//            async function loadComponents() {
//                vm.model.itemsListComponents = await stockSearchService.listComponents({
//                    p2_pofinish_keyno: p2PoFinishKeyno,
//                    who: vm.model.bgComponentSelection.selected
//                });
//            }

//            // #endregion LOAD PROCEDURE CALL

//            // #region BUTTON RADIO FUNCTIONS

//            vm.selectBgComponentSelection = function (value) {
//                vm.model.bgComponentSelection.selected = value;
//                loadComponents();
//            }

//            // #endregion BUTTON RADIO FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadComponents();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
